import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TablePermission } from 'src/app/models/admin/permissions/table-permission';
import { TablePermissionListing } from 'src/app/models/admin/permissions/table-permission-listing';
import { Role } from 'src/app/models/admin/role';
import { AdminService } from 'src/app/services/admin.service';
import { StringLocalizerService } from 'src/app/services/string-localizer.service';

@Component({
    selector: 'app-permissions-table',
    imports: [CommonModule],
    templateUrl: './permissions-table.component.html',
    styleUrls: ['./permissions-table.component.css']
})
export class PermissionsTableComponent {
  public strings: {} = {};
  public selectedRole: Role;
  public tablePermission: TablePermission | null = null;
  @Input() tableId: string = "";
  @Input() fullAccessPermission: boolean = false;
  

  constructor(
      private adminService: AdminService, 
      private stringLocalizerService: StringLocalizerService) 
    {
      this.stringLocalizerService.strings.subscribe(s => {
      if (s) {
        this.strings = this.stringLocalizerService.getSection("admin");
      }});
      this.adminService.$selectedRole.subscribe(r => {
        if (r) {
          this.selectedRole = r;
          this.tablePermission = r.permissions.tables.dataSets
            .find(t => t.name === this.tableId) ?? null;
        }
      });
    }

    ngOnInit(): void {
      if (!this.selectedRole || !this.tableId) {
        return;
      }
      this.tablePermission = this.selectedRole.permissions.tables.dataSets.find(t => t.name === this.tableId) || null;            // will no-op if data not ready yet
    }

    public tablesFullAccessEnabled(): boolean {
      return (this.selectedRole.permissions.tables.admin == true)
    }
    
    public tableAdminEnabled(): boolean {
      if(this.tablesFullAccessEnabled()){
        return true;
      }
      if(this.tablePermission != null){
        if(this.tablePermission.permission != null){
          return this.tablePermission.permission?.split(",").some(p => p.includes("Admin"));
        }
      }
      return false;
    }
  
    public tablePermissionEnabled(permissionName: string): boolean {
      var enabled = false;
      if (this.tablePermission && this.tablePermission.permission.split(",").some(p => p.includes(permissionName))) {
        enabled = true;
      }
      if (this.selectedRole.permissions.tables.admin) {
        enabled = true;
      }
      return enabled;
    }

  public toggleTableAdmin() {
    this.selectedRole.permissions.tables.admin = !this.selectedRole.permissions.tables.admin;
    if (this.selectedRole.permissions.tables.admin === true) {
      this.selectedRole.permissions.tables.dataSets.forEach(table => {
        table.permission += (", Admin");
      })
    } else {
      this.selectedRole.permissions.tables.dataSets.forEach(table => {
        let removeAdmin = table.permission.replace(", Admin", '')
        table.permission = removeAdmin;
      })
    }
    this.adminService.addRoleToUpdatedCollection(this.selectedRole);
  }


  public toggleTablePermission(permissionName: string) {
    if (!this.selectedRole) {
      return;
    }
    if (!this.tablePermission) {
      const newPerm: TablePermission = { name: this.tableId, permission: permissionName };
      this.selectedRole.permissions.tables.dataSets.push(newPerm);
      this.tablePermission = newPerm;
    } 
    else {
      var permissionsArray = this.tablePermission.permission.split(",");
      for (let i = 0; i < permissionsArray.length; i++) {
        permissionsArray[i] = permissionsArray[i].trim();
      }
      if (permissionsArray.some(i => i === 'None')) {
        permissionsArray.splice(permissionsArray.indexOf("None"), 1);
      }
      if (permissionsArray.some(p => p === permissionName)) {
        permissionsArray.splice(permissionsArray.indexOf(permissionName), 1);
      }
      else {
        permissionsArray.push(permissionName);
      }
      this.tablePermission.permission = permissionsArray.join(",")
      if (this.tablePermission.permission.length === 0) {
        this.tablePermission.permission = "None"
      }
      
      // swap permission in selectedRole with updated tablePermission
      var spliceIndex = this.selectedRole.permissions.tables.dataSets.findIndex(t => t.name === this.tablePermission.name);
      if(spliceIndex >= 0){
        this.selectedRole.permissions.tables.dataSets.splice(spliceIndex, 1);
      }
      this.selectedRole.permissions.tables.dataSets.push(this.tablePermission);
      
    }
    this.adminService.addRoleToUpdatedCollection(this.selectedRole);
  }
}
